import { CheckCircle2, Clock } from "lucide-react";
import { useLang } from "../../i18n/LangContext";
import { CallButton, TextButton } from "../site/CallButton";
import { useSettings } from "../../context/SettingsContext";
import { Summary } from "./Summary";

export const Confirmation = ({ result, onNew }) => {
  const { t } = useLang();
  const { settings } = useSettings();
  const method = result.contact_method === "text" ? t("wizard.text").toLowerCase() : t("wizard.call").toLowerCase();
  return (
    <div className="space-y-8" data-testid="confirmation-screen-container">
      <div className="rounded-2xl border border-[#2E2E3A] bg-[#18181F] p-6 sm:p-8">
        <CheckCircle2 className="h-12 w-12 text-emerald-400" aria-hidden="true" />
        <h1 className="mt-4 text-4xl sm:text-5xl font-extrabold uppercase" data-testid="confirmation-title">{t("confirm.title")}</h1>
        {result.duplicate && <p className="mt-3 text-sm text-yellow-300" data-testid="confirmation-duplicate-note">{t("confirm.duplicate")}</p>}
        <p className="mt-6 text-xs font-bold uppercase tracking-[0.2em] text-gray-400">{t("confirm.refLabel")}</p>
        <p className="mt-1 font-mono text-3xl sm:text-4xl font-bold text-[#FACC15]" data-testid="confirmation-reference-number">{result.ref}</p>
        <p className="mt-2 text-sm text-gray-400">{t("confirm.keepRef")}</p>
        <p className="mt-6 inline-flex items-center gap-2 rounded-full border border-yellow-400/40 bg-yellow-400/10 px-4 py-2 text-sm font-bold uppercase text-yellow-300" data-testid="confirmation-status">
          <Clock className="h-4 w-4 beacon" aria-hidden="true" /> {t("confirm.awaiting")}
        </p>
        <p className="mt-4 max-w-xl text-gray-200">{t("confirm.body", { method })}</p>
        {settings.phone && (
          <div className="mt-6">
            <p className="mb-3 text-sm text-gray-400">{t("confirm.callUs")}</p>
            <div className="flex flex-col sm:flex-row gap-3">
              <CallButton testId="confirmation-call-btn" className="px-6 py-3" showNumber />
              <TextButton testId="confirmation-text-btn" className="px-6 py-3" />
            </div>
          </div>
        )}
        <p className="mt-6 text-sm font-semibold text-red-300">{t("confirm.safety")}</p>
      </div>
      <div>
        <h2 className="mb-4 text-xl font-extrabold uppercase">{t("confirm.summary")}</h2>
        <Summary data={result} />
      </div>
      <button type="button" onClick={onNew} className="btn-ghost px-6 py-3" data-testid="confirmation-new-request-btn">{t("confirm.newRequest")}</button>
    </div>
  );
};
